import { render, staticRenderFns } from "./AccountsView.vue?vue&type=template&id=79e2bec2&scoped=true&"
import script from "./AccountsView.vue?vue&type=script&lang=js&"
export * from "./AccountsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e2bec2",
  null
  
)

export default component.exports